/**
 * The sections of the listing editor workspace.
 *
 * Order is the navigation order and the DOM order of the panels. `basic` is
 * the default and the one the editor returns to whenever it is opened for a
 * different listing or for a new one.
 *
 * "Vorschau" comes last because it reads the other six rather than adding to
 * them: it renders the current form state as a card and writes nothing.
 */
export const EDITOR_SECTIONS = [
  { id: "basic", label: "Basisinformationen" },
  { id: "description", label: "Beschreibung" },
  { id: "amenities", label: "Ausstattung" },
  { id: "marketing", label: "Marketing Details" },
  { id: "location", label: "Adresse & Lage" },
  { id: "publishing", label: "Veröffentlichung" },
  { id: "preview", label: "Vorschau" },
];

export const DEFAULT_EDITOR_SECTION = "basic";
